import type { ReactNode } from "react"

/** Карточка формы рассылки: заголовок с пояснением и поля под ним. */
export function Section({
	title,
	hint,
	children,
}: {
	title: string
	hint?: string
	children: ReactNode
}) {
	return (
		<section className="space-y-5 rounded-2xl border border-border bg-card p-5">
			<header>
				<h2 className="text-base font-semibold tracking-tight">{title}</h2>
				{hint ? <p className="mt-0.5 text-xs text-muted-foreground">{hint}</p> : null}
			</header>
			{children}
		</section>
	)
}
